<template>
  <el-dialog
    :close-on-click-modal="false"
    :show-close="showClose"
    v-on="$listeners"
    :title="$attrs.title"
    :visible="visible"
    :width="$attrs.width || '460px'"
    @close="$emit('cancel')"
  >
    <slot></slot>
    <div slot="footer">
      <el-button @click="$emit('cancel')">取 消</el-button>

      <slot name="confirm-btn">
        <el-button type="primary" :loading="$attrs.loading" @click="$emit('confirm')">确 定</el-button>
      </slot>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 10px 20px;
}

.footer-row {
  display: flex;
  align-items: center;
  .left-area {
    flex: 1;
  }
}
</style>
